import { AttributeDefinition } from '../attributes/attributeDefinition';
import { QuestionDefinitionModel } from '../form/question-definition-model';

export class EvaluationsQuestion extends QuestionDefinitionModel {
  public static parse(data: any): EvaluationsQuestion {
    if (!data) return null;

    let evaluationQuestion = new EvaluationsQuestion();
    Object.assign(evaluationQuestion, data);

    evaluationQuestion.attributeDefinition = AttributeDefinition.parse(
      evaluationQuestion.attributeDefinition
    );
    return evaluationQuestion;
  }
}
